import { atomFamily } from "recoil";

import {
    type DigitalGood,
    type Discoverability,
    type MyLensesLensCta,
    MyLensesLensCtaText,
    MyLensesLensCtaType,
    type SurfaceType,
    Visibility,
} from "../../gql-generated/types";

import { StateKeys } from "./StateKeys";

// TODO - Move this file closer to where its used

export const lensTagsAtomById = atomFamily<readonly string[], string>({
    key: StateKeys.LensTags,
    default: [],
});

export const lensSpectaclesTagsAtomById = atomFamily<readonly string[], string>({
    key: StateKeys.SpectaclesTags,
    default: [],
});

export const lensVisibilityAtomById = atomFamily<Visibility, string>({
    key: StateKeys.Visibility,
    default: Visibility.VisibilityDontPublishToSnapchat,
});

export const lensCtaAtomById = atomFamily<MyLensesLensCta | null, string>({
    key: StateKeys.LensCta,
    default: {
        type: MyLensesLensCtaType.CtaTypeUnset,
        text: MyLensesLensCtaText.CtaTextUnset,
    },
});

export const isGameUserProvidedById = atomFamily<boolean, string>({
    key: StateKeys.IsGameUserProvided,
    default: false,
});

export const DEFAULT_PREVIEW_NAME = "lens_studio_preview.mp4";

export const primaryCategoryIdAtomById = atomFamily<string, string>({
    key: StateKeys.PrimaryCategory,
    default: "",
});

export const secondaryCategoryIdAtomById = atomFamily<string | null, string>({
    key: StateKeys.SecondaryCategory,
    default: "",
});

export const digitalGoodsAtomById = atomFamily<DigitalGood[], string>({
    key: StateKeys.DigitalGoods,
    default: [],
});

export const defaultDiscoverability: Discoverability = {
    description: "",
    daysTimesHolidaysList: [],
    locationsList: [],
    tagsList: [],
};

export const discoverabilityById = atomFamily<Discoverability | null, string>({
    key: StateKeys.Discoverability,
    default: defaultDiscoverability,
});

export const lensCreatorPayoutEnrolledById = atomFamily<boolean, string>({
    key: StateKeys.LensCreatorPayoutEnrolled,
    default: false,
});

export const lensDescriptionAtomById = atomFamily<string, string>({
    key: StateKeys.LensDescription,
    default: "",
});

export const releaseNoteAtomById = atomFamily<string | null, string>({
    key: StateKeys.ReleaseNote,
    default: null,
});

export const lensSurfaceTypeAtomById = atomFamily<readonly SurfaceType[], string>({
    key: StateKeys.SurfaceType,
    default: [],
});
